import { USER_FORM_PERMISSIONS, USER_FORM_PERMISSIONS_NAMES } from '@/constants/common';

export default function() {
    USER_FORM_PERMISSIONS_NAMES.forEach(p => {
        this[p] = { ...USER_FORM_PERMISSIONS[p], value: false }
    })
}
